module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiEyp8kv8JHgFVrJJfecnFHGPc.9ed361bb.woff2";